import type { Story } from '@/mocks/featuredStories';
import Section from './Section';
import StoryCover from './StoryCover';

interface Props {
  stories: Story[];
  onOpen: (s: Story) => void;
}

export default function Weekly({ stories, onOpen }: Props) {
  const [lead, ...rest] = stories;
  return (
    <Section
      id="weekly"
      icon="ri-calendar-check-line"
      title="本周必看"
      en="WEEKLY MUST-WATCH"
      desc="编辑部每周初从一周资讯中挑出最值得回味的几条，帮你把时间花在刀刃上。本周必看，错过任何一条都可惜。"
      right={
        <span className="flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
          <i className="ri-calendar-line" /> 本周已更新 {stories.length} 期
        </span>
      }
    >
      {/* 编辑大稿 */}
      <button
        type="button"
        onClick={() => onOpen(lead)}
        className="group grid w-full overflow-hidden rounded-2xl border border-background-200 bg-background-100 text-left transition hover:border-primary-300 lg:grid-cols-5"
      >
        <div className="relative overflow-hidden lg:col-span-2">
          <span className="absolute left-4 top-4 z-10 rounded bg-foreground-950 px-2 py-0.5 text-xs font-bold text-accent-400">
            本期头牌
          </span>
          <div className="aspect-[16/10] h-full w-full lg:aspect-auto lg:min-h-[260px]">
            <StoryCover story={lead} className="transition duration-500 group-hover:scale-105" />
          </div>
        </div>
        <div className="flex flex-col justify-center gap-3 p-5 md:p-7 lg:col-span-3">
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <span className="rounded bg-primary-100 px-1.5 py-0.5 text-primary-700">{lead.category}</span>
            <span>{lead.source}</span>
            <span>· {lead.timeLabel}</span>
            <span className="ml-auto hidden items-center gap-1 text-accent-700 sm:flex">
              <i className="ri-fire-fill" /> {lead.heat} 热度
            </span>
          </div>
          <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-2xl">
            {lead.title}
          </h3>
          <p className="text-sm leading-relaxed text-foreground-600 md:line-clamp-2">{lead.dek}</p>
          <span className="mt-1 inline-flex w-fit items-center gap-1.5 rounded-full bg-primary-500 px-4 py-1.5 text-sm font-medium text-background-50 transition group-hover:bg-primary-600">
            <i className="ri-book-open-line" /> 点开阅读全文
          </span>
        </div>
      </button>

      {/* 其余速览 */}
      <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {rest.map((s, i) => (
          <button
            key={s.id}
            type="button"
            onClick={() => onOpen(s)}
            className="group flex flex-col rounded-xl border border-background-200 bg-background-50 p-4 text-left transition hover:-translate-y-1 hover:border-primary-300"
          >
            <span className="flex items-center gap-2 text-xs text-foreground-500">
              <span className="flex h-5 w-5 items-center justify-center rounded bg-background-200 font-heading text-[11px] font-bold text-foreground-700">
                {i + 1}
              </span>
              <span className="rounded bg-secondary-100 px-1.5 text-secondary-800">{s.category}</span>
            </span>
            <h4 className="mt-3 line-clamp-2 flex-1 text-[15px] font-semibold leading-snug text-foreground-900 group-hover:text-primary-700">
              {s.title}
            </h4>
            <p className="mt-2 flex items-center justify-between text-xs text-foreground-500">
              <span>{s.timeLabel}</span>
              <span className="flex items-center gap-1 text-accent-700">
                <i className="ri-fire-fill" /> {s.heat}
              </span>
            </p>
          </button>
        ))}
      </div>
    </Section>
  );
}